import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'pm-bin-list',
  templateUrl: './bin-list.component.html',
  styleUrls: ['./bin-list.component.sass']
})
export class BinListComponent {
  public pageTitle = 'BINES';

  // constructor() {}

  // ngOnInit() {}

  // ngAfterViewInit() {
  //   $('#menu-catalogos').click();
  // }

  // ngOnDestroy() {}
  public showBines = true;
  public showAddBin = false;
  public showEditBin = false;
  public editnumber = 0;
}
